export const AGENT_LIST_REQ = 'AGENT_LIST_REQ'
export const AGENT_LIST_SUCCESS = 'AGENT_LIST_SUCCESS'
export const AGENT_LIST_ERROR = 'AGENT_LIST_ERROR'
export const AGENT_LIST_RESET_STATUS = 'AGENT_LIST_RESET_STATUS'

export const AGENT_DETAILS_REQ = 'AGENT_DETAILS_REQ'
export const AGENT_DETAILS_SUCCESS = 'AGENT_DETAILS_SUCCESS'
export const AGENT_DETAILS_ERROR = 'AGENT_DETAILS_ERROR'

export const CUSTOM_HOSTNAME_REQ = 'CUSTOM_HOSTNAME_REQ'
export const CUSTOM_HOSTNAME_SUCCESS = 'CUSTOM_HOSTNAME_SUCCESS'
export const CUSTOM_HOSTNAME_ERROR = 'CUSTOM_HOSTNAME_ERROR'

export const BULK_HOSTNAME_REQ = 'BULK_HOSTNAME_REQ'
export const BULK_HOSTNAME_SUCCESS = 'BULK_HOSTNAME_SUCCESS'
export const BULK_HOSTNAME_ERROR = 'BULK_HOSTNAME_ERROR'

export const DECOMMISSION_AGENTS_REQ = 'DECOMMISSION_AGENTS_REQ'
export const DECOMMISSION_AGENTS_SUCCESS = 'DECOMMISSION_AGENTS_SUCCESS'
export const DECOMMISSION_AGENTS_ERROR = 'DECOMMISSION_AGENTS_ERROR'

export const UPDATE_AGENT_LOCATION_REQ = 'UPDATE_AGENT_LOCATION_REQ'
export const UPDATE_AGENT_LOCATION_SUCCESS = 'UPDATE_AGENT_LOCATION_SUCCESS'
export const UPDATE_AGENT_LOCATION_ERROR = 'UPDATE_AGENT_LOCATION_ERROR'

export const EVENTS_CONSUMED_REQ = 'EVENTS_CONSUMED_REQ'
export const EVENTS_CONSUMED_SUCCESS = 'EVENTS_CONSUMED_SUCCESS'
export const EVENTS_CONSUMED_ERROR = 'EVENTS_CONSUMED_ERROR'

export const CONTAINER_LIST_REQ = 'CONTAINER_LIST_REQ'
export const CONTAINER_LIST_SUCCESS = 'CONTAINER_LIST_SUCCESS'
export const CONTAINER_LIST_ERROR = 'CONTAINER_LIST_ERROR'
export const CONTAINER_LIST_RESET_STATUS = 'CONTAINER_LIST_RESET_STATUS'

export const CONTAINERINFO_BY_AGENTID_REQ = 'CONTAINERINFO_BY_AGENTID_REQ'
export const CONTAINERINFO_BY_AGENTID_SUCCESS = 'CONTAINERINFO_BY_AGENTID_SUCCESS'
export const CONTAINERINFO_BY_AGENTID_ERROR = 'CONTAINERINFO_BY_AGENTID_ERROR'
export const CONTAINERINFO_BY_AGENTID_RESET_STATUS = 'CONTAINERINFO_BY_AGENTID_RESET_STATUS'

export const CONTAINERINFO_BY_INSTANCEID_REQ = 'CONTAINERINFO_BY_INSTANCEID_REQ'
export const CONTAINERINFO_BY_INSTANCEID_SUCCESS = 'CONTAINERINFO_BY_INSTANCEID_SUCCESS'
export const CONTAINERINFO_BY_INSTANCEID_ERROR = 'CONTAINERINFO_BY_INSTANCEID_ERROR'
export const CONTAINERINFO_BY_INSTANCEID_RESET_STATUS = 'CONTAINERINFO_BY_INSTANCEID_RESET_STATUS'

export const AGENT_CONTAINER_INFO_REQ = 'AGENT_CONTAINER_INFO_REQ'
export const AGENT_CONTAINER_INFO_SUCCESS = 'AGENT_CONTAINER_INFO_SUCCESS'
export const AGENT_CONTAINER_INFO_ERROR = 'AGENT_CONTAINER_INFO_ERROR'
export const AGENT_CONTAINER_INFO_RESET_STATUS = 'AGENT_CONTAINER_INFO_RESET_STATUS'

export const ACCOUNTKEY_AGENT_LIST_REQ = 'ACCOUNTKEY_AGENT_LIST_REQ'
export const ACCOUNTKEY_AGENT_LIST_SUCCESS = 'ACCOUNTKEY_AGENT_LIST_SUCCESS'
export const ACCOUNTKEY_AGENT_LIST_ERROR = 'ACCOUNTKEY_AGENT_LIST_ERROR'
export const ACCOUNTKEY_AGENT_LIST_RESET_STATUS = 'ACCOUNTKEY_AGENT_LIST_RESET_STATUS'

export const ACCOUNTKEY_CONTAINER_LIST_REQ = 'ACCOUNTKEY_CONTAINER_LIST_REQ'
export const ACCOUNTKEY_CONTAINER_LIST_SUCCESS = 'ACCOUNTKEY_CONTAINER_LIST_SUCCESS'
export const ACCOUNTKEY_CONTAINER_LIST_ERROR = 'ACCOUNTKEY_CONTAINER_LIST_ERROR'
export const ACCOUNTKEY_CONTAINER_LIST_RESET_STATUS = 'ACCOUNTKEY_CONTAINER_LIST_RESET_STATUS'

export const CONTAINER_PROGRESSION_COUNT_REQ = 'CONTAINER_PROGRESSION_COUNT_REQ'
export const CONTAINER_PROGRESSION_COUNT_SUCCESS = 'CONTAINER_PROGRESSION_COUNT_SUCCESS'
export const CONTAINER_PROGRESSION_COUNT_ERROR = 'CONTAINER_PROGRESSION_COUNT_ERROR'
export const CONTAINER_PROGRESSION_COUNT_RESET_STATUS = 'CONTAINER_PROGRESSION_COUNT_RESET_STATUS'

export const CONTAINER_VIEW_PREFERENCES = 'CONTAINER_VIEW_PREFERENCES'
export const SAVE_CONTAINER_VIEW_PREFERENCES = 'SAVE_CONTAINER_VIEW_PREFERENCES'

export const CONTAINER_IMAGES_LIST_REQ = 'CONTAINER_IMAGES_LIST_REQ'
export const CONTAINER_IMAGES_LIST_SUCCESS = 'CONTAINER_IMAGES_LIST_SUCCESS'
export const CONTAINER_IMAGES_LIST_ERROR = 'CONTAINER_IMAGES_LIST_ERROR'
export const CONTAINER_IMAGES_LIST_RESET_STATUS = 'CONTAINER_IMAGES_LIST_RESET_STATUS'

export const CONTAINER_IMAGES_VIEW_PREFERENCES = 'CONTAINER_IMAGES_VIEW_PREFERENCES'
export const SAVE_CONTAINER_IMAGES_VIEW_PREFERENCES = 'SAVE_CONTAINER_IMAGES_VIEW_PREFERENCES'

export const ASSET_SUMMARY_VIEW = 'ASSET_SUMMARY_VIEW'
export const ASSET_SUMMARY_VIEW_SUCCESS = 'ASSET_SUMMARY_VIEW_SUCCESS'
export const ASSET_SUMMARY_VIEW_ERROR = 'ASSET_SUMMARY_VIEW_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/agents/agents.type.js